<template>
  <b-container>
    <!-- <div
    v-infinite-scroll="getData"
    :infinite-scroll-disabled="busy"
    infinite-scroll-distance="5"> -->
    <div>
    <b-row class="mt-100 mt-sm-70 search-wrap mb-50 pos-rel">
      <b-col xl="3" lg="3" md="12" class="search-left-column">
        <!-- <h4 class="mb-3 fz-30 fw-500 text-black"><b>Filter By</b></h4> -->
        <b-card-group deck>
          <b-card>
            <template>
              <div class="accordion border-none" role="tablist">
                <b-card no-body class="mb-1">
                  <b-card-header header-tag="header" class="py-3 px-1" role="tab" style='border:0 !important;padding-bottom:0;'>
                    <div class="d-flex" block v-b-toggle.accordion-12 variant="info">
                      <a href="javascript:void(0);" class="fz-16 fw-600 text-black">Category</a>
                      <div class="ml-auto">
                        <i class="fa fa-chevron-down fz-14" aria-hidden="true"></i>
                      </div>
                    </div>
                  </b-card-header>

                  <b-collapse id="accordion-12" visible  class='category-accordion-visible-wr ' style='border:0 !important' role="tabpanel">
                    <b-card-header header-tag="header" visible class="py-3 px-1 category-accordion" role="tab">
                    <div class="d-flex" block v-b-toggle.accordion-3 variant="info">
                      <a href="javascript:void(0);" class="fz-16 fw-600 text-black">Select Categories</a>
                      <div class="ml-auto">
                        <i class="fa fa-chevron-down fz-14" aria-hidden="true"></i>
                      </div>
                    </div>
                  </b-card-header>
                  <b-collapse id="accordion-3" visible v-model="isAccordion3Visible"  class='category-accordion-visible-wr inner' role="tabpanel">
                    <b-card-body class="pos-relative">
                      <div class="input-group search-bar mt-2">
                        <SearchIcon   v-show="!search && !isFocused" class="absolute" style='width: 25px;z-index: 1;top: 7px;left: 6px;fill:#00000075' />
                        <input type="text"  
                          @focus="isFocused = true" 
                          @blur="isFocused = false"
                        class="form-control bordered" v-model="search" placeholder="" aria-describedby="basic-addon2">
                        <div class="tt-menu" style="border:0 !important" >
                          <b-form-group
                            v-slot="{ ariaDescribedby }"
                          >
                            <!-- <b-form-checkbox
                              v-for="(category,id) in filterCategory"
                              v-model="filtersValue.selectedCategoryData"
                              :key="id"
                              :value="category"
                              :aria-describedby="ariaDescribedby"
                              @change ="filterByData()"
                            >
                              {{ category.role_name }}
                            </b-form-checkbox> -->
                            <label
                              v-for="(category, id) in filterCategory"
                              :key="id"
                              class="custom-checkbox-label"
                              :aria-describedby="ariaDescribedby"
                            >
                              <input
                                type="checkbox"
                                v-model="filtersValue.selectedCategoryData"
                                :value="category"
                                @change="filterByData()"
                                style='padding-left:30px'
                                class="custom-checkbox-input"
                              />
                              <span class="custom-checkbox-box"></span>
                              {{ category.role_name }}
                            </label>
                          </b-form-group>
                        </div>
                      </div>
                      
                    </b-card-body>
                  </b-collapse>
                  </b-collapse>

                
                  <b-card-header header-tag="header" class="py-3 px-1" role="tab">
                    <div class="d-flex" block v-b-toggle.accordion-1 variant="info">
                      <a href="javascript:void(0);" class="fz-16 fw-600 text-black">Experience Level</a>
                      <div class="ml-auto">
                        <i class="fa fa-chevron-down fz-14" aria-hidden="true"></i>
                      </div>
                    </div>
                  </b-card-header>
                  <b-collapse id="accordion-1" visible role="tabpanel">
                    <b-card-body>
                      <b-card-text class='mt-4'>
                        <!-- <b-form-checkbox 
                          v-for="(exp_level, id) in ExperienceLevelData"
                          :key="id"
                          v-model="filtersValue.experienceLevel"
                          class="mb-2 mt-2"
                          :value="exp_level"
                          @change  ="filterByData()"
                        >
                          {{exp_level.title}}
                        </b-form-checkbox> -->
                        <label
                              v-for="(exp_level, id) in ExperienceLevelData"
                              :key="id"
                              class="custom-checkbox-label"
                            >
                              <input
                                type="checkbox"
                                v-model="filtersValue.experienceLevel"
                                :value="exp_level"
                                @change="filterByData()"
                                class="custom-checkbox-input"
                              />
                              <span class="custom-checkbox-box"></span>
                              {{ exp_level.title }}
                            </label>
                      
                      </b-card-text>
                    </b-card-body>
                  </b-collapse>



                  <b-card-header header-tag="header" class="py-3 px-1" role="tab">
                    <div class="d-flex" block v-b-toggle.accordion-6 variant="info">
                      <a href="javascript:void(0);" class="fz-16 fw-600 text-black">Hours per week</a>
                      <div class="ml-auto">
                        <i class="fa fa-chevron-down fz-14" aria-hidden="true"></i>
                      </div>
                    </div>
                  </b-card-header>
                  <b-collapse id="accordion-6" visible role="tabpanel">
                    <b-card-body>
                      <b-card-text v-if="employmentTypeData.length > 0" class='mt-4'>
                        <!-- <b-form-checkbox 
                          v-for="(emp, id) in employmentTypeData"
                          :key="id"  
                          v-model="filtersValue.hoursperweek"
                          class="mb-2 mt-2"
                          :value="emp.employment_id"
                          @change  ="filterByData()"
                        >
                        {{emp.text}}
                        </b-form-checkbox> -->

                          <label
                            v-for="(emp, id) in employmentTypeData"
                            :key="id"
                            class="custom-checkbox-label"
                          >
                            <input
                              type="checkbox"
                              v-model="filtersValue.hoursperweek"
                              :value="emp.employment_id"
                              @change="filterByData()"
                              class="custom-checkbox-input"
                            />
                            <span class="custom-checkbox-box"></span>
                            {{ emp.text }}
                          </label>
                      </b-card-text>
                    </b-card-body>
                  </b-collapse>

           
                  <b-card-header header-tag="header" class="py-3 px-1" role="tab">
                    <div class="d-flex" block v-b-toggle.accordion-2 variant="info">
                      <a href="javascript:void(0);" class="fz-16 fw-600 text-black">Number of proposals</a>
                      <div class="ml-auto">
                        <i class="fa fa-chevron-down fz-14" aria-hidden="true"></i>
                      </div>
                    </div>
                  </b-card-header>
                  <b-collapse id="accordion-2" visible role="tabpanel">
                    <b-card-body>
                      <b-card-text class='mt-4'>
                        <!-- <b-form-checkbox
                          v-model="filtersValue.numberOfProposal"
                          id="checkbox-4"
                          name="checkbox-4"
                          class="mb-2 mt-2"
                          value="lessthan_5"
                          @change ="filterByData()"
                        >
                          Less than 5
                        </b-form-checkbox>
                         -->
                                  <!-- <b-form-checkbox
                          v-model="filtersValue.numberOfProposal"
                          id="checkbox-5"
                          name="checkbox-5"
                          class="mb-2"
                          value="5_to_10"
                          @change ="filterByData()"

                        >
                          5 to 10
                        </b-form-checkbox> -->

                        <!-- 
                        <b-form-checkbox
                          v-model="filtersValue.numberOfProposal"
                          id="checkbox-6"
                          name="checkbox-6"
                          class="mb-2"
                          value="10_to_15"
                          @change ="filterByData()"

                        >
                          10 to 15 
                        </b-form-checkbox> -->
                 <!-- <b-form-checkbox
                          v-model="filtersValue.numberOfProposal"

                          id="checkbox-8"
                          name="checkbox-8"
                          class="mb-2"
                          value="15_to_20"
                          @change ="filterByData()"

                        >
                          15 to 20 
                        </b-form-checkbox> -->

                        
                  
                        <!-- <b-form-checkbox
                          v-model="filtersValue.numberOfProposal"

                          id="checkbox-9"
                          name="checkbox-9"
                          class="mb-2"
                          value="morethan_20"
                          @change ="filterByData()"

                        >
                          More than 20 
                        </b-form-checkbox> -->

                        <label
                            class="custom-checkbox-label"
                          >
                            <input
                              type="checkbox"
                              id="checkbox-4"
                              v-model="filtersValue.numberOfProposal"
                              value="lessthan_5"
                              @change="filterByData()"
                              class="custom-checkbox-input mb-2 mt-2"
                            />
                            <span class="custom-checkbox-box"></span>
                            Less than 5
                          </label>

                          <label
                            class="custom-checkbox-label"
                          >
                            <input
                              type="checkbox"
                              v-model="filtersValue.numberOfProposal"
                              id="checkbox-5"
                              name="checkbox-5"
                              value='5_to_10'
                              @change="filterByData()"
                              class="custom-checkbox-input mb-2 mt-2"
                            />
                            <span class="custom-checkbox-box"></span>
                            5 to 10
                          </label>


                          <label
                            class="custom-checkbox-label"
                          >
                            <input
                              type="checkbox"
                              v-model="filtersValue.numberOfProposal"
                              id="checkbox-6"
                              name="checkbox-6"
                              @change="filterByData()"
                              value="10_to_15"
                              class="custom-checkbox-input mb-2 mt-2"
                            />
                            <span class="custom-checkbox-box"></span>
                            10 to 15 
                          </label>


                          <label
                            class="custom-checkbox-label"
                          >
                            <input
                              type="checkbox"
                              v-model="filtersValue.numberOfProposal"
                              id="checkbox-8"
                              name="checkbox-8"
                              @change="filterByData()"
                              value="15_to_20"
                              class="custom-checkbox-input mb-2 mt-2"
                            />
                            <span class="custom-checkbox-box"></span>
                            15 to 20 
                          </label>


                          <label
                            class="custom-checkbox-label"
                          >
                            <input
                              type="checkbox"
                              v-model="filtersValue.numberOfProposal"
                              id="checkbox-9"
                              name="checkbox-9"
                              @change="filterByData()"
                              value="morethan_20"
                              class="custom-checkbox-input mb-2 mt-2"
                            />
                            <span class="custom-checkbox-box"></span>
                            More than 20 
                          </label>
                      </b-card-text>
                    </b-card-body>
                  </b-collapse>

       

                  <b-card-header header-tag="header" class="py-3 px-1" role="tab">
                    <div class="d-flex" block v-b-toggle.accordion-4 variant="info">
                      <a href="javascript:void(0);" class="fz-16 fw-600 text-black">Project Length</a>
                      <div class="ml-auto">
                        <i class="fa fa-chevron-down fz-14" aria-hidden="true"></i>
                      </div>
                    </div>
                  </b-card-header>
                  <b-collapse id="accordion-4" visible role="tabpanel">
                    <b-card-body>
                      <b-card-text v-if="projectLengthData.length > 0" class='mt-4'>
                        <!-- <b-form-checkbox
                          v-for="(pro_length , id) in projectLengthData"
                          :key="id"
                          v-model="filtersValue.projectLength"
                          class="mb-2 mt-2"
                          :value="pro_length"
                          @change ="filterByData()"

                        >
                          {{pro_length.title}}
                        </b-form-checkbox> -->

                        <label
                            v-for="(pro_length, id) in projectLengthData"
                            :key="id"
                            class="custom-checkbox-label"
                          >
                            <input
                              type="checkbox"
                              v-model="filtersValue.projectLength"
                              :value="pro_length"
                              @change="filterByData()"
                              class="custom-checkbox-input"
                            />
                            <span class="custom-checkbox-box"></span>
                            {{pro_length.title}}
                          </label>

                      </b-card-text>
                    </b-card-body>
                  </b-collapse>

                  <b-card-header header-tag="header" class="py-3 px-1" role="tab" style='border:0 !important;padding-bottom:0;'>
                    <div class="d-flex" block v-b-toggle.accordion-14 variant="info">
                      <a href="javascript:void(0);" class="fz-16 fw-600 text-black">Client location</a>
                      <div class="ml-auto">
                        <i class="fa fa-chevron-down fz-14" aria-hidden="true"></i>
                      </div>
                    </div>
                  </b-card-header>
                  <b-collapse id="accordion-14" visible class='category-accordion-visible-wr' style="border:0 !important"  role="tabpanel">


                  <b-card-header header-tag="header" class="py-3 px-1 category-accordion" role="tab">
                    <div class="d-flex" block v-b-toggle.accordion-5 variant="info">
                      <a href="javascript:void(0);" class="fz-16 fw-600 text-black">Select client locations</a>
                      <div class="ml-auto">
                        <i class="fa fa-chevron-down fz-14" aria-hidden="true"></i>
                      </div>
                    </div>
                  </b-card-header>

                  <b-collapse id="accordion-5" v-model="isAccordion5Visible"  class='category-accordion-visible-wr inner'  style='border:0 !important;padding:0 !important' role="tabpanel">
                    <b-card-body class="pos-relative">
                      <div class="input-group search-bar mt-2" style='border: 1px solid #00000025;padding: 10px;border-radius: 5px;'>
                        
                        <SearchIcon 
                        v-show="!location && !isLocationFocusedDesktop"
                         class="absolute" style="width: 25px;z-index: 1;top: 17px;left: 14px;fill:#00000075" />
                        <input type="text" 
                          @focus="isLocationFocusedDesktop = true" 
                          @blur="isLocationFocusedDesktop = false"
                          class="form-control border-none" v-model="location" placeholder="" aria-describedby="basic-addon2" v-on:keyup="searchLocation()">
                        <div class="tt-menu"  style="border:0 !important">
                          <b-form-group
                            v-slot="{ ariaDescribedby }"
                          >
                            <!-- <b-form-checkbox
                              v-for="(category,id) in filterCategory"
                              v-model="filtersValue.selectedCategoryData"
                              :key="id"
                              :value="category"
                              :aria-describedby="ariaDescribedby"
                              @change ="filterByData()"
                            >
                              {{ category.role_name }}
                            </b-form-checkbox> -->
                              
                            <label
                              v-for="(loc, id) in locationData"
                              :key="id"
                              class="custom-checkbox-label"
                            >
                              <input
                                type="checkbox"
                                :value="loc"
                                :key="id"
                                :aria-describedby="ariaDescribedby"
                                v-model="filtersValue.locationData"
                                style='padding-left:30px'
                                @change="filterByData()"
                                class="custom-checkbox-input"
                              />
                              <span class="custom-checkbox-box"></span>
                              <span style='width: 80%'>
                                {{loc.location}}
                              </span>
                          </label>
                          </b-form-group>
                        </div>
                      </div>
                      
                    </b-card-body>
                  </b-collapse>
                  </b-collapse>

                </b-card>
              </div>
            </template>
          </b-card>
        </b-card-group>
      </b-col>
      <b-col xl="9" lg="9" md="12" class="col-12">
        <div class="chat-hamburger pos-absolute r-5  z-1" style='top:35px' v-b-toggle.filter-sidebar>
          <i class="fa fa-bars px-2 py-2 border mr-2" aria-hidden="true"></i>
        </div>
        <b-sidebar id="filter-sidebar" title="Filter" shadow>
          <b-card-group deck class="t-sm-0">
            <b-card>
              <!-- mobile version -->
              <template>
                <div class="accordion border-none" role="tablist">
                  <b-card no-body class="mb-1">

                    <b-card-header header-tag="header" class="py-3 px-1" role="tab" style='border:0 !important;padding-bottom:0;'>
                    <div class="d-flex" block v-b-toggle.accordion-12 variant="info">
                      <a href="javascript:void(0);" class="fz-16 fw-600 text-black">Category</a>
                      <div class="ml-auto">
                        <i class="fa fa-chevron-down fz-14" aria-hidden="true"></i>
                      </div>
                    </div>
                  </b-card-header>

                  <b-collapse id="accordion-12" visible  class='category-accordion-visible-wr ' style='border:0 !important' role="tabpanel">
                    <b-card-header header-tag="header" visible class="py-3 px-1 category-accordion" role="tab">
                    <div class="d-flex" block v-b-toggle.accordion-3 variant="info">
                      <a href="javascript:void(0);" class="fz-16 fw-600 text-black">Select Categories</a>
                      <div class="ml-auto">
                        <i class="fa fa-chevron-down fz-14" aria-hidden="true"></i>
                      </div>
                    </div>
                  </b-card-header>
                  <b-collapse id="accordion-3" visible v-model="isAccordion3Visible"  class='category-accordion-visible-wr inner' role="tabpanel">
                    <b-card-body class="pos-relative">
                      <div class="input-group search-bar mt-2">
                        <SearchIcon class="absolute"  v-show="!search && !isFocused" style='    width: 25px;height: 25px;z-index: 1;top: 7px;left: 6px;fill: rgba(0, 0, 0, 0.46);background: transparent;padding: 0;' />
                        <input type="text" class="form-control bordered"                           @focus="isFocused = true" 
                        @blur="isFocused = false" v-model="search" placeholder="" aria-describedby="basic-addon2">

                        <div class="tt-menu" style="border:0 !important" >
                          <b-form-group
                            v-slot="{ ariaDescribedby }"
                          >
                            <!-- <b-form-checkbox
                              v-for="(category,id) in filterCategory"
                              v-model="filtersValue.selectedCategoryData"
                              :key="id"
                              :value="category"
                              :aria-describedby="ariaDescribedby"
                              @change ="filterByData()"
                            >
                              {{ category.role_name }}
                            </b-form-checkbox> -->
                            <label
                              v-for="(category, id) in filterCategory"
                              :key="id"
                              class="custom-checkbox-label"
                              :aria-describedby="ariaDescribedby"
                            >
                              <input
                                type="checkbox"
                                v-model="filtersValue.selectedCategoryData"
                                :value="category"
                                @change="filterByData()"
                                style='padding-left:30px'
                                class="custom-checkbox-input"
                              />
                              <span class="custom-checkbox-box"></span>
                              {{ category.role_name }}
                            </label>
                          </b-form-group>
                        </div>
                      </div>
                      
                    </b-card-body>
                  </b-collapse>
                  </b-collapse>

                    <b-card-header header-tag="header" class="py-3 px-1" role="tab">
                      <div class="d-flex" block v-b-toggle.accordion-1 variant="info">
                        <a href="javascript:void(0);" class="fz-16 fw-600 text-black">Experience Level</a>
                        <div class="ml-auto">
                          <i class="fa fa-chevron-down fz-14" aria-hidden="true"></i>
                        </div>
                      </div>
                    </b-card-header>
                    <b-collapse id="accordion-1" visible role="tabpanel">
                      <b-card-body>
                        <b-card-text class='mt-4'>
                          <label
                              v-for="(exp_level, id) in ExperienceLevelData"
                              :key="id"
                              class="custom-checkbox-label"
                            >
                              <input
                                type="checkbox"
                                v-model="filtersValue.experienceLevel"
                                :value="exp_level"
                                @change="filterByData()"
                                class="custom-checkbox-input"
                              />
                              <span class="custom-checkbox-box"></span>
                              {{ exp_level.title }}
                            </label>

                        
                        </b-card-text>
                      </b-card-body>
                    </b-collapse>


                    <b-card-header header-tag="header" class="py-3 px-1" role="tab">
                      <div class="d-flex" block v-b-toggle.accordion-6 variant="info">
                        <a href="javascript:void(0);" class="fz-16 fw-600 text-black">Hours per week</a>
                        <div class="ml-auto">
                          <i class="fa fa-chevron-down fz-14" aria-hidden="true"></i>
                        </div>
                      </div>
                    </b-card-header>
                    <b-collapse id="accordion-6" visible role="tabpanel">
                      <b-card-body>
                        <b-card-text v-if="employmentTypeData.length > 0" class='mt-4'>
                        <!-- <b-form-checkbox 
                          v-for="(emp, id) in employmentTypeData"
                          :key="id"  
                          v-model="filtersValue.hoursperweek"
                          class="mb-2 mt-2"
                          :value="emp.employment_id"
                          @change  ="filterByData()"
                        >
                        {{emp.text}}
                        </b-form-checkbox> -->

                          <label
                            v-for="(emp, id) in employmentTypeData"
                            :key="id"
                            class="custom-checkbox-label"
                          >
                            <input
                              type="checkbox"
                              v-model="filtersValue.hoursperweek"
                              :value="emp.employment_id"
                              @change="filterByData()"
                              class="custom-checkbox-input"
                            />
                            <span class="custom-checkbox-box"></span>
                            {{ emp.text }}
                          </label>
                      </b-card-text>
                      </b-card-body>
                    </b-collapse>

             
                    <b-card-header header-tag="header" class="py-3 px-1" role="tab">
                      <div class="d-flex" block v-b-toggle.accordion-2 variant="info">
                        <a href="javascript:void(0);" class="fz-16 fw-600 text-black">Number of proposals</a>
                        <div class="ml-auto">
                          <i class="fa fa-chevron-down fz-14" aria-hidden="true"></i>
                        </div>
                      </div>
                    </b-card-header>
                    <b-collapse id="accordion-2" visible role="tabpanel">
                      <b-card-body>
                        <b-card-text class='mt-4'>
                        <!-- <b-form-checkbox
                          v-model="filtersValue.numberOfProposal"
                          id="checkbox-4"
                          name="checkbox-4"
                          class="mb-2 mt-2"
                          value="lessthan_5"
                          @change ="filterByData()"
                        >
                          Less than 5
                        </b-form-checkbox>
                         -->
                                  <!-- <b-form-checkbox
                          v-model="filtersValue.numberOfProposal"
                          id="checkbox-5"
                          name="checkbox-5"
                          class="mb-2"
                          value="5_to_10"
                          @change ="filterByData()"

                        >
                          5 to 10
                        </b-form-checkbox> -->

                        <!-- 
                        <b-form-checkbox
                          v-model="filtersValue.numberOfProposal"
                          id="checkbox-6"
                          name="checkbox-6"
                          class="mb-2"
                          value="10_to_15"
                          @change ="filterByData()"

                        >
                          10 to 15 
                        </b-form-checkbox> -->
                 <!-- <b-form-checkbox
                          v-model="filtersValue.numberOfProposal"

                          id="checkbox-8"
                          name="checkbox-8"
                          class="mb-2"
                          value="15_to_20"
                          @change ="filterByData()"

                        >
                          15 to 20 
                        </b-form-checkbox> -->

                        
                  
                        <!-- <b-form-checkbox
                          v-model="filtersValue.numberOfProposal"

                          id="checkbox-9"
                          name="checkbox-9"
                          class="mb-2"
                          value="morethan_20"
                          @change ="filterByData()"

                        >
                          More than 20 
                        </b-form-checkbox> -->

                        <label
                            class="custom-checkbox-label"
                          >
                            <input
                              type="checkbox"
                              id="checkbox-4"
                              v-model="filtersValue.numberOfProposal"
                              value="lessthan_5"
                              @change="filterByData()"
                              class="custom-checkbox-input mb-2 mt-2"
                            />
                            <span class="custom-checkbox-box"></span>
                            Less than 5
                          </label>

                          <label
                            class="custom-checkbox-label"
                          >
                            <input
                              type="checkbox"
                              v-model="filtersValue.numberOfProposal"
                              id="checkbox-5"
                              name="checkbox-5"
                              value='5_to_10'
                              @change="filterByData()"
                              class="custom-checkbox-input mb-2 mt-2"
                            />
                            <span class="custom-checkbox-box"></span>
                            5 to 10
                          </label>


                          <label
                            class="custom-checkbox-label"
                          >
                            <input
                              type="checkbox"
                              v-model="filtersValue.numberOfProposal"
                              id="checkbox-6"
                              name="checkbox-6"
                              @change="filterByData()"
                              value="10_to_15"
                              class="custom-checkbox-input mb-2 mt-2"
                            />
                            <span class="custom-checkbox-box"></span>
                            10 to 15 
                          </label>


                          <label
                            class="custom-checkbox-label"
                          >
                            <input
                              type="checkbox"
                              v-model="filtersValue.numberOfProposal"
                              id="checkbox-8"
                              name="checkbox-8"
                              @change="filterByData()"
                              value="15_to_20"
                              class="custom-checkbox-input mb-2 mt-2"
                            />
                            <span class="custom-checkbox-box"></span>
                            15 to 20 
                          </label>


                          <label
                            class="custom-checkbox-label"
                          >
                            <input
                              type="checkbox"
                              v-model="filtersValue.numberOfProposal"
                              id="checkbox-9"
                              name="checkbox-9"
                              @change="filterByData()"
                              value="morethan_20"
                              class="custom-checkbox-input mb-2 mt-2"
                            />
                            <span class="custom-checkbox-box"></span>
                            More than 20 
                          </label>
                      </b-card-text>
                      </b-card-body>
                    </b-collapse>

          

                    <b-card-header header-tag="header" class="py-3 px-1" role="tab">
                      <div class="d-flex" block v-b-toggle.accordion-4 variant="info">
                        <a href="javascript:void(0);" class="fz-16 fw-600 text-black">Project Length</a>
                        <div class="ml-auto">
                          <i class="fa fa-chevron-down fz-14" aria-hidden="true"></i>
                        </div>
                      </div>
                    </b-card-header>
                    <b-collapse id="accordion-4" visible role="tabpanel">
                      <b-card-body>
                        <b-card-text v-if="projectLengthData.length > 0" class='mt-4'>
                        <!-- <b-form-checkbox
                          v-for="(pro_length , id) in projectLengthData"
                          :key="id"
                          v-model="filtersValue.projectLength"
                          class="mb-2 mt-2"
                          :value="pro_length"
                          @change ="filterByData()"

                        >
                          {{pro_length.title}}
                        </b-form-checkbox> -->

                        <label
                            v-for="(pro_length, id) in projectLengthData"
                            :key="id"
                            class="custom-checkbox-label"
                          >
                            <input
                              type="checkbox"
                              v-model="filtersValue.projectLength"
                              :value="pro_length"
                              @change="filterByData()"
                              class="custom-checkbox-input"
                            />
                            <span class="custom-checkbox-box"></span>
                            {{pro_length.title}}
                          </label>

                      </b-card-text>
                      </b-card-body>
                    </b-collapse>

                    <b-card-header header-tag="header" class="py-3 px-1" role="tab" style='border:0 !important;padding-bottom:0;'>
                    <div class="d-flex" block v-b-toggle.accordion-14 variant="info">
                      <a href="javascript:void(0);" class="fz-16 fw-600 text-black">Client location</a>
                      <div class="ml-auto">
                        <i class="fa fa-chevron-down fz-14" aria-hidden="true"></i>
                      </div>
                    </div>
                  </b-card-header>
                  <b-collapse id="accordion-14"  class='category-accordion-visible-wr' style="border:0 !important;padding:0" role="tabpanel">


                  <b-card-header header-tag="header" class="py-3 px-1 category-accordion" role="tab">
                    <div class="d-flex" block v-b-toggle.accordion-5 variant="info">
                      <a href="javascript:void(0);" class="fz-16 fw-600 text-black">Select client locations</a>
                      <div class="ml-auto">
                        <i class="fa fa-chevron-down fz-14" aria-hidden="true"></i>
                      </div>
                    </div>
                  </b-card-header>

                  <b-collapse id="accordion-5" v-model="isAccordion5Visible"  class='category-accordion-visible-wr inner'  style='border:0 !important' role="tabpanel">
                    <b-card-body class="pos-relative">
                      <div class="input-group search-bar mt-2" style='border: 1px solid #00000025;padding: 10px;border-radius: 5px;'>

                        <SearchIcon 
                        v-show="!location && !isLocationFocused"
                        class="absolute" style="    width: 25px;
                          height: 25px;
                          z-index: 1;
                          top: 17px;left: 14px;
                          fill: rgba(0, 0, 0, 0.46);
                          background: transparent;
                          padding: 0;" />
                        <input type="text" 
                          @focus="isLocationFocused = true" 
                          @blur="isLocationFocused = false"
                        class="form-control border-none" v-model="location" placeholder="" aria-describedby="basic-addon2" v-on:keyup="searchLocation()">
                        <div class="tt-menu"  style="border:0 !important">
                          <b-form-group
                            v-slot="{ ariaDescribedby }"
                          >
                            <!-- <b-form-checkbox
                              v-for="(category,id) in filterCategory"
                              v-model="filtersValue.selectedCategoryData"
                              :key="id"
                              :value="category"
                              :aria-describedby="ariaDescribedby"
                              @change ="filterByData()"
                            >
                              {{ category.role_name }}
                            </b-form-checkbox> -->
                              
                            <label
                              v-for="(loc, id) in locationData"
                              :key="id"
                              class="custom-checkbox-label"
                            >
                              <input
                                type="checkbox"
                                :value="loc"
                                :key="id"
                                :aria-describedby="ariaDescribedby"
                                v-model="filtersValue.locationData"
                                style='padding-left:30px'
                                @change="filterByData()"
                                class="custom-checkbox-input"
                              />
                              <span class="custom-checkbox-box"></span>
                              {{loc.location}}
                          </label>
                          </b-form-group>
                        </div>
                      </div>
                      
                    </b-card-body>
                  </b-collapse>
                  </b-collapse>
                  </b-card>
                </div>
              </template>
            </b-card>
          </b-card-group>
        </b-sidebar>
        <b-card no-body class="freelancer-wrap mt-12 mt-sm-0 bg-white">
      
          <div class="tab-content" id="pills-tabContent">
            <div class="tab-pane fade show active" id="pills-home" role="tabpanel" aria-labelledby="pills-home-tab">
                <div class="search-filter-wrapper px-4 border-bottom pb-3 mb-3">
                  <b-row>
                    <b-col xl="12" lg="12" md="12">
                      <div class="input-group search-bar">
                        <!-- <input type="text" class="form-control border-none" v-model="titleSearch" @keyup="filterByData()" placeholder="Search for jobsssss" aria-describedby="basic-addon2"> -->
                        <form class="header-search-wr find-job" @submit.prevent="filterByData()" :class="{ typing: searchData.length > 0 }">
                          <SearchIcon class="absolute" />
                          <input v-model="titleSearch" type="text" name="search" id="search" placeholder="Search for jobs by title, company, location, or keywords…" @input="getSearchData"
                            @keydown.enter="handleEnterKey('web')" 
                            @blur="handleBlur"
                            @keyup="filterByData()" 
                            @focus="getSearchData"
                            autocomplete="off" 
                            autocorrect="off" 
                            autocapitalize="off" 
                            spellcheck="false"
                            aria-autocomplete="none"
                          />
                           <span 
                            v-if="titleSearch.length" 
                            @click="clearSearch"
                            class="reset-header-search"
                          >
                            ✖
                          </span>
                          <template v-if="filteredSearchData.length > 0">
                            <div class="auto-fill-data-wr">
                              <ul>
                                <li v-for="(serach,index) in filteredSearchData"  :key="index"   @click="gotoSearchPage(serach,'web')" >
                                  <svg v-if="serach.search_type==1" xmlns="http://www.w3.org/2000/svg" xmlns:sketch="http://www.bohemiancoding.com/sketch/ns" xmlns:xlink="http://www.w3.org/1999/xlink" height="21px" version="1.1" viewBox="0 0 20 21" width="20px"><title/><desc/><defs/><g fill="none" fill-rule="evenodd" id="Page-1" stroke="none" stroke-width="1"><g fill="#000000" id="Core" opacity="0.9" transform="translate(-464.000000, -254.000000)"><g id="history" transform="translate(464.000000, 254.500000)"><path d="M10.5,0 C7,0 3.9,1.9 2.3,4.8 L0,2.5 L0,9 L6.5,9 L3.7,6.2 C5,3.7 7.5,2 10.5,2 C14.6,2 18,5.4 18,9.5 C18,13.6 14.6,17 10.5,17 C7.2,17 4.5,14.9 3.4,12 L1.3,12 C2.4,16 6.1,19 10.5,19 C15.8,19 20,14.7 20,9.5 C20,4.3 15.7,0 10.5,0 L10.5,0 Z M9,5 L9,10.1 L13.7,12.9 L14.5,11.6 L10.5,9.2 L10.5,5 L9,5 L9,5 Z" id="Shape"/></g></g></g></svg>
                                  <SearchIcon v-if="serach.search_type==2" class="absolute" />{{ serach.search_word }}
                                </li>
                              </ul>
                            </div>
                          </template>
                        </form>
                      </div>
                    </b-col>
                    <!-- <b-col xl="2" lg="2" md="12">
                      <b-button class="btn btn-theme w-100" disabled><i class="fa fa-envelope" aria-hidden="true"></i> Save Search</b-button>
                    </b-col> -->
                    <b-col xl="12" lg="12" md="12">
                      <ul class="inline-block align-items-center fz-14 post tags mb-0">
                        <span v-if="filtersValue.hoursperweek.length > 0">
                          <li class="mr-1 inline-block align-items-center bg-theme" v-for="(expLevel,id) in filtersValue.hoursperweek" :key="id"> 
                            <a href="javascript:void(0);" class="cursor-pointer d-flex align-items-center text-white" v-if="expLevel==1">
                             Adhoc - Less than 30 hrs/week
                              <svg width="13" height="13" viewBox="0 0 13 13" fill="#FFF" xmlns="http://www.w3.org/2000/svg" class="ml-2" @click="removeFilterValue('hoursperweek',id)"><rect width="0.878423" height="8.78423" rx="0.439212" transform="matrix(0.703924 0.710276 -0.703924 0.710276 9.22266 3.08838)" fill="#FFF"></rect><rect width="0.878423" height="8.78423" rx="0.439212" transform="matrix(0.703929 -0.71027 0.703929 0.71027 3.03906 3.7124)" fill="#FFF"></rect></svg>
                            </a>
                            <a href="javascript:void(0);" class="cursor-pointer d-flex align-items-center text-white" v-if="expLevel==2">
                               Residence - More than 40 hrs/week
                              <svg width="13" height="13" viewBox="0 0 13 13" fill="#FFF" xmlns="http://www.w3.org/2000/svg" class="ml-2" @click="removeFilterValue('hoursperweek',id)"><rect width="0.878423" height="8.78423" rx="0.439212" transform="matrix(0.703924 0.710276 -0.703924 0.710276 9.22266 3.08838)" fill="#FFF"></rect><rect width="0.878423" height="8.78423" rx="0.439212" transform="matrix(0.703929 -0.71027 0.703929 0.71027 3.03906 3.7124)" fill="#FFF"></rect></svg>
                            </a>
                            <a href="javascript:void(0);" class="cursor-pointer d-flex align-items-center text-white" v-if="expLevel==3">
                               Residence - More than 48 hrs/week
                              <svg width="13" height="13" viewBox="0 0 13 13" fill="#FFF" xmlns="http://www.w3.org/2000/svg" class="ml-2" @click="removeFilterValue('hoursperweek',id)"><rect width="0.878423" height="8.78423" rx="0.439212" transform="matrix(0.703924 0.710276 -0.703924 0.710276 9.22266 3.08838)" fill="#FFF"></rect><rect width="0.878423" height="8.78423" rx="0.439212" transform="matrix(0.703929 -0.71027 0.703929 0.71027 3.03906 3.7124)" fill="#FFF"></rect></svg>
                            </a>
                          </li>
                        </span>
                        <span v-if="filtersValue.experienceLevel.length > 0">
                          <li class="mr-1 inline-block align-items-center bg-theme" v-for="(expLevel,id) in filtersValue.experienceLevel" :key="id"> 
                            <a href="javascript:void(0);" class="cursor-pointer d-flex align-items-center text-white">
                              {{expLevel.title}}
                              <svg width="13" height="13" viewBox="0 0 13 13" fill="#FFF" xmlns="http://www.w3.org/2000/svg" class="ml-2" @click="removeFilterValue('experienceLevel',id)"><rect width="0.878423" height="8.78423" rx="0.439212" transform="matrix(0.703924 0.710276 -0.703924 0.710276 9.22266 3.08838)" fill="#FFF"></rect><rect width="0.878423" height="8.78423" rx="0.439212" transform="matrix(0.703929 -0.71027 0.703929 0.71027 3.03906 3.7124)" fill="#FFF"></rect></svg>
                            </a>
                          </li>
                        </span>
                        <span v-if="filtersValue.numberOfProposal.length > 0">
                          <li class="mr-1 inline-block align-items-center bg-theme" v-for="(n_proposal,id) in filtersValue.numberOfProposal" :key="id"> 
                            <a href="javascript:void(0);" class="cursor-pointer d-flex align-items-center text-white" v-if="n_proposal == 'lessthan_5'">
                              Less than 5
                              <svg width="13" height="13" viewBox="0 0 13 13" fill="#FFF" xmlns="http://www.w3.org/2000/svg" class="ml-2" @click="removeFilterValue('numberOfProposal',id)"><rect width="0.878423" height="8.78423" rx="0.439212" transform="matrix(0.703924 0.710276 -0.703924 0.710276 9.22266 3.08838)" fill="#FFF"></rect><rect width="0.878423" height="8.78423" rx="0.439212" transform="matrix(0.703929 -0.71027 0.703929 0.71027 3.03906 3.7124)" fill="#FFF"></rect></svg>
                            </a>

                            <a href="javascript:void(0);" class="cursor-pointer d-flex align-items-center text-white" v-if="n_proposal == '5_to_10'">
                              5 to 10 
                              <svg width="13" height="13" viewBox="0 0 13 13" fill="#FFF" xmlns="http://www.w3.org/2000/svg" class="ml-2" @click="removeFilterValue('numberOfProposal',id)"><rect width="0.878423" height="8.78423" rx="0.439212" transform="matrix(0.703924 0.710276 -0.703924 0.710276 9.22266 3.08838)" fill="#FFF"></rect><rect width="0.878423" height="8.78423" rx="0.439212" transform="matrix(0.703929 -0.71027 0.703929 0.71027 3.03906 3.7124)" fill="#FFF"></rect></svg>
                            </a>

                            <a href="javascript:void(0);" class="cursor-pointer d-flex align-items-center text-white" v-if="n_proposal == '10_to_15'">
                              10 to 15 
                              <svg width="13" height="13" viewBox="0 0 13 13" fill="#FFF" xmlns="http://www.w3.org/2000/svg" class="ml-2" @click="removeFilterValue('numberOfProposal',id)"><rect width="0.878423" height="8.78423" rx="0.439212" transform="matrix(0.703924 0.710276 -0.703924 0.710276 9.22266 3.08838)" fill="#FFF"></rect><rect width="0.878423" height="8.78423" rx="0.439212" transform="matrix(0.703929 -0.71027 0.703929 0.71027 3.03906 3.7124)" fill="#FFF"></rect></svg>
                            </a>

                            <a href="javascript:void(0);" class="cursor-pointer d-flex align-items-center text-white" v-if="n_proposal == '15_to_20'">
                              15 to 20 
                              <svg width="13" height="13" viewBox="0 0 13 13" fill="#FFF" xmlns="http://www.w3.org/2000/svg" class="ml-2" @click="removeFilterValue('numberOfProposal',id)"><rect width="0.878423" height="8.78423" rx="0.439212" transform="matrix(0.703924 0.710276 -0.703924 0.710276 9.22266 3.08838)" fill="#FFF"></rect><rect width="0.878423" height="8.78423" rx="0.439212" transform="matrix(0.703929 -0.71027 0.703929 0.71027 3.03906 3.7124)" fill="#FFF"></rect></svg>
                            </a>

                            <a href="javascript:void(0);" class="cursor-pointer d-flex align-items-center text-white" v-if="n_proposal == 'morethan_20'">
                              More than 20 
                              <svg width="13" height="13" viewBox="0 0 13 13" fill="#FFF" xmlns="http://www.w3.org/2000/svg" class="ml-2" @click="removeFilterValue('numberOfProposal',id)"><rect width="0.878423" height="8.78423" rx="0.439212" transform="matrix(0.703924 0.710276 -0.703924 0.710276 9.22266 3.08838)" fill="#FFF"></rect><rect width="0.878423" height="8.78423" rx="0.439212" transform="matrix(0.703929 -0.71027 0.703929 0.71027 3.03906 3.7124)" fill="#FFF"></rect></svg>
                            </a>
                          </li>
                        </span>
                        <span v-if="filtersValue.selectedCategoryData.length > 0">
                          <li class="mr-1 inline-block align-items-center bg-theme" v-for="(cat_data,id) in filtersValue.selectedCategoryData" :key="id"> 
                            <a href="javascript:void(0);" class="cursor-pointer d-flex align-items-center text-white">
                               {{cat_data.role_name}}
                              <svg width="13" height="13" viewBox="0 0 13 13" fill="#FFF" xmlns="http://www.w3.org/2000/svg" class="ml-2" @click="removeFilterValue('selectedCategoryData',id)"><rect width="0.878423" height="8.78423" rx="0.439212" transform="matrix(0.703924 0.710276 -0.703924 0.710276 9.22266 3.08838)" fill="#FFF"></rect><rect width="0.878423" height="8.78423" rx="0.439212" transform="matrix(0.703929 -0.71027 0.703929 0.71027 3.03906 3.7124)" fill="#FFF"></rect></svg>
                            </a>
                          </li>
                        </span>
                        <span v-if="filtersValue.projectLength.length > 0">
                          <li class="mr-1 inline-block align-items-center bg-theme" v-for="(pro_length,id) in filtersValue.projectLength" :key="id"> 
                            <a href="javascript:void(0);" class="cursor-pointer d-flex align-items-center text-white">
                              {{pro_length.title}}
                              <svg width="13" height="13" viewBox="0 0 13 13" fill="#FFF" xmlns="http://www.w3.org/2000/svg" class="ml-2" @click="removeFilterValue('projectLength',id)"><rect width="0.878423" height="8.78423" rx="0.439212" transform="matrix(0.703924 0.710276 -0.703924 0.710276 9.22266 3.08838)" fill="#FFF"></rect><rect width="0.878423" height="8.78423" rx="0.439212" transform="matrix(0.703929 -0.71027 0.703929 0.71027 3.03906 3.7124)" fill="#FFF"></rect></svg>
                            </a>
                          </li>
                        </span>
                        <span v-if="filtersValue.locationData.length > 0">
                          <li class="mr-1 inline-block align-items-center bg-theme" v-for="(loc_data,id) in filtersValue.locationData" :key="id"> 
                            <a href="javascript:void(0);" class="cursor-pointer d-flex align-items-center text-white">
                               {{loc_data.location}}
                              <svg width="13" height="13" viewBox="0 0 13 13" fill="#FFF" xmlns="http://www.w3.org/2000/svg" class="ml-2" @click="removeFilterValue('locationData',id)"><rect width="0.878423" height="8.78423" rx="0.439212" transform="matrix(0.703924 0.710276 -0.703924 0.710276 9.22266 3.08838)" fill="#FFF"></rect><rect width="0.878423" height="8.78423" rx="0.439212" transform="matrix(0.703929 -0.71027 0.703929 0.71027 3.03906 3.7124)" fill="#FFF"></rect></svg>
                            </a>
                          </li>
                        </span>
                        
                        <a href="javascript:void(0);" class="cursor-pointer text-black d-block" @click="clearFilter()" v-if="hideClearBtn">
                          Clear Filter
                        </a>
                      </ul>
                    </b-col>
                  </b-row>
                  <div class="d-flex align-items-center mt-2 save-job-sort-wr" style="justify-content: space-between;">
                    <h4 class="fz-16 fw-600 mb-0 d-flex align-items-center">
                      <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="#F2613B" class="bi bi-rss mr-2" viewBox="0 0 16 16">
                        <path d="M14 1a1 1 0 0 1 1 1v12a1 1 0 0 1-1 1H2a1 1 0 0 1-1-1V2a1 1 0 0 1 1-1h12zM2 0a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V2a2 2 0 0 0-2-2H2z"/>
                        <path d="M5.5 12a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0zm-3-8.5a1 1 0 0 1 1-1c5.523 0 10 4.477 10 10a1 1 0 1 1-2 0 8 8 0 0 0-8-8 1 1 0 0 1-1-1zm0 4a1 1 0 0 1 1-1 6 6 0 0 1 6 6 1 1 0 1 1-2 0 4 4 0 0 0-4-4 1 1 0 0 1-1-1z"/>
                      </svg>
                      {{proposalDetails.filterJobcount}} jobs found
                    </h4>

                    <div class="saved-job-filter-wr">
                        <ul class="nav nav-pills py-2" id="pills-tab" role="tablist">
                          <a href="javascript:void(0);" @click="$router.push('/saved-jobs').catch(()=>{})">
                          <li class="nav-item saved-jobs-text-wr" role="presentation">
                            <svg xmlns="http://www.w3.org/2000/svg" width="20px" height="20px" viewBox="0 0 24 24" fill="none">
                              <path fill-rule="evenodd" clip-rule="evenodd" d="M12 6.00019C10.2006 3.90317 7.19377 3.2551 4.93923 5.17534C2.68468 7.09558 2.36727 10.3061 4.13778 12.5772C5.60984 14.4654 10.0648 18.4479 11.5249 19.7369C11.6882 19.8811 11.7699 19.9532 11.8652 19.9815C11.9483 20.0062 12.0393 20.0062 12.1225 19.9815C12.2178 19.9532 12.2994 19.8811 12.4628 19.7369C13.9229 18.4479 18.3778 14.4654 19.8499 12.5772C21.6204 10.3061 21.3417 7.07538 19.0484 5.17534C16.7551 3.2753 13.7994 3.90317 12 6.00019Z" stroke="#f2613c" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                            </svg>
                            <button style="padding-left: 6px;" class="nav-link" id="pills-home-tab" data-bs-toggle="pill" data-bs-target="#pills-profile" type="button" role="tab" aria-controls="pills-profile" aria-selected="false">Saved Jobs (<span class="number-of-saved-jobs" v-html="(proposalDetails.saved_job > 0)?proposalDetails.saved_job:''"></span>)</button>
                          </li>
                          </a>
                        </ul>
                         <div class="ml-auto d-flex align-items-center sort-jobs-wr">
                           <label>Sort by:</label>
                           <b-form-select v-model="filtersValue.sort" :options="sortoptions" @change="filterByData()" class="mt-0"></b-form-select>
                         </div>
                       </div>
                  
                    </div>
                    
                </div>


  
              <div v-if="!dataStatus && postData?.length > 0">
                <div class="job-card py-2 px-4 pb-4 mb-2 position-relative freelanceSearch cursor-pointer" v-b-toggle.sidebar-right  v-for="(data,index) in postData" :key="index" :class="(data.readStatus!=1)?'unread-bg':'job-viewed'" :id="data.jobs_id"  v-on:click="postDetailsclick(data.jobs_id)">
                  <div class="action-btn">
                    <span class="job-viewed-text">Job Viewed</span>

                    <button type="button" v-if="data.action == 3" class="btn btn-secondary br-50 btn-archive saved-btn heart" style='margin:0 !important' :id="'res_'+data.jobs_id" v-on:click="(event) => { event.stopPropagation(); savePost(data, index); }">
                      <svg xmlns="http://www.w3.org/2000/svg" width="20px" height="20px" viewBox="0 0 24 24" fill="#f2613c">
                        <path fill-rule="evenodd" clip-rule="evenodd" d="M12 6.00019C10.2006 3.90317 7.19377 3.2551 4.93923 5.17534C2.68468 7.09558 2.36727 10.3061 4.13778 12.5772C5.60984 14.4654 10.0648 18.4479 11.5249 19.7369C11.6882 19.8811 11.7699 19.9532 11.8652 19.9815C11.9483 20.0062 12.0393 20.0062 12.1225 19.9815C12.2178 19.9532 12.2994 19.8811 12.4628 19.7369C13.9229 18.4479 18.3778 14.4654 19.8499 12.5772C21.6204 10.3061 21.3417 7.07538 19.0484 5.17534C16.7551 3.2753 13.7994 3.90317 12 6.00019Z" stroke="#f2613c" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                      </svg>
                      <!-- <svg width="14" height="19" viewBox="0 0 14 19" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M1.82903 0.620117H11.997C12.6246 0.620117 13.1542 1.12649 13.1542 1.77727L13.1542 16.8113C13.1542 16.8115 13.1542 16.8116 13.1542 16.8118C13.1524 17.5271 12.2615 17.9031 11.7348 17.3707L11.7329 17.3688L7.8604 13.4974C7.35368 12.9738 6.47239 12.9738 5.96568 13.4974L2.0932 17.3688L2.09124 17.3707C1.56473 17.903 0.67387 17.5274 0.671875 16.8118V1.77727C0.671875 1.12649 1.20151 0.620117 1.82903 0.620117Z" stroke="black"/>
                      </svg> -->
                    </button>
                    <button type="button" v-else class="btn btn-secondary br-50 btn-archive heart" :id="'res_'+data.jobs_id" v-on:click="(event) => { event.stopPropagation(); savePost(data, index); }">
                      <svg xmlns="http://www.w3.org/2000/svg" width="20px" height="20px" viewBox="0 0 24 24" fill="none">
                        <path fill-rule="evenodd" clip-rule="evenodd" d="M12 6.00019C10.2006 3.90317 7.19377 3.2551 4.93923 5.17534C2.68468 7.09558 2.36727 10.3061 4.13778 12.5772C5.60984 14.4654 10.0648 18.4479 11.5249 19.7369C11.6882 19.8811 11.7699 19.9532 11.8652 19.9815C11.9483 20.0062 12.0393 20.0062 12.1225 19.9815C12.2178 19.9532 12.2994 19.8811 12.4628 19.7369C13.9229 18.4479 18.3778 14.4654 19.8499 12.5772C21.6204 10.3061 21.3417 7.07538 19.0484 5.17534C16.7551 3.2753 13.7994 3.90317 12 6.00019Z" stroke="#f2613c" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                      </svg>
                    </button>
                  </div>
                  <span class="job-posted-text">Posted {{data.time}}</span>
                  <h5 class="text-black fz-18 fw-600 title-heading mb-0 freelancer-search-name" v-on:click="postDetailsclick(data.jobs_id)">{{data.job_title}}</h5>
                  
                  <div>

                    <ul class="flex align-items-center fw-600 fz-14 post text-muted mb-2 freelancer-search-page-ul" v-on:click="postDetailsclick(data.jobs_id)">

                      <li class="find-job-flex category"><svg xmlns="http://www.w3.org/2000/svg" width="25px" height="25px" viewBox="0 0 24 24" fill="none"><path fill-rule="evenodd" clip-rule="evenodd" d="M3.75 4.5L4.5 3.75H10.5L11.25 4.5V10.5L10.5 11.25H4.5L3.75 10.5V4.5ZM5.25 5.25V9.75H9.75V5.25H5.25ZM13.5 3.75L12.75 4.5V10.5L13.5 11.25H19.5L20.25 10.5V4.5L19.5 3.75H13.5ZM14.25 9.75V5.25H18.75V9.75H14.25ZM17.25 20.25H15.75V17.25H12.75V15.75H15.75V12.75H17.25V15.75H20.25V17.25H17.25V20.25ZM4.5 12.75L3.75 13.5V19.5L4.5 20.25H10.5L11.25 19.5V13.5L10.5 12.75H4.5ZM5.25 18.75V14.25H9.75V18.75H5.25Z" fill="#00000085"/></svg>
                        {{data.quality_inspector}}</li> 
                      <li class="find-job-flex">
                        <svg width="24" height="29" viewBox="0 0 24 29" fill="none" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" clip-rule="evenodd" d="M11.9999 5.28027C8.37764 5.28027 5.40918 8.40136 5.40918 12.2748C5.40918 14.3585 6.46842 16.8771 8.23787 19.6617C8.85278 20.6294 9.51552 21.5658 10.1854 22.4404C10.6054 22.9889 10.952 23.4148 11.1785 23.6801C11.6242 24.202 12.3759 24.2018 12.8214 23.68C13.0479 23.4148 13.3945 22.9889 13.8145 22.4404C14.4844 21.5658 15.1471 20.6294 15.762 19.6617C17.5315 16.8771 18.5907 14.3585 18.5907 12.2748C18.5906 8.40135 15.6222 5.28027 11.9999 5.28027ZM9.18859 18.847C7.55932 16.283 6.59072 13.9799 6.59072 12.2748C6.59072 9.19124 9.00544 6.65236 11.9999 6.65236C14.9944 6.65236 17.4091 9.19123 17.4092 12.2748C17.4092 13.9799 16.4406 16.283 14.8113 18.847C13.7963 20.4444 12.7477 21.8156 11.9999 22.6934C11.2521 21.8155 10.2036 20.4443 9.18859 18.847ZM12 14.7608C10.7673 14.7608 9.77138 13.5702 9.77138 12.1142C9.77138 10.6582 10.7673 9.4677 12 9.4677C13.2326 9.4677 14.2285 10.6582 14.2285 12.1142C14.2285 13.5703 13.2326 14.7608 12 14.7608ZM12 13.5663C12.6578 13.5663 13.1999 12.9182 13.1999 12.1142C13.1999 11.3103 12.6578 10.6621 12 10.6621C11.3421 10.6621 10.7999 11.3103 10.7999 12.1142C10.7999 12.9182 11.3421 13.5663 12 13.5663Z" fill="#00000085"></path></svg>
                         {{data.country_name+', '+data.state_name+', '+data.city_name}}
                      </li> 
                      
                    </ul>
                  </div>
                  <!-- <vue-read-more-smooth :lines="3" class="mt-2 mb-2"> -->
                  <p class="fz-16 text-black mb-2 search-description" v-html="(data.scope_of_work)" v-on:click="postDetailsclick(data.jobs_id)"> </p>
                  <!-- <p class="fz-16 text-black mb-2" v-html="getHtmlContent(data.scope_of_work)"  v-b-toggle.sidebar-right v-on:click="postDetailsclick(data.jobs_id)"> </p> -->
                  <!-- </vue-read-more-smooth> -->
                  <p class="fz-14 text-black client-location"><svg width="24" height="29" viewBox="0 0 24 29" fill="none" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" clip-rule="evenodd" d="M11.9999 5.28027C8.37764 5.28027 5.40918 8.40136 5.40918 12.2748C5.40918 14.3585 6.46842 16.8771 8.23787 19.6617C8.85278 20.6294 9.51552 21.5658 10.1854 22.4404C10.6054 22.9889 10.952 23.4148 11.1785 23.6801C11.6242 24.202 12.3759 24.2018 12.8214 23.68C13.0479 23.4148 13.3945 22.9889 13.8145 22.4404C14.4844 21.5658 15.1471 20.6294 15.762 19.6617C17.5315 16.8771 18.5907 14.3585 18.5907 12.2748C18.5906 8.40135 15.6222 5.28027 11.9999 5.28027ZM9.18859 18.847C7.55932 16.283 6.59072 13.9799 6.59072 12.2748C6.59072 9.19124 9.00544 6.65236 11.9999 6.65236C14.9944 6.65236 17.4091 9.19123 17.4092 12.2748C17.4092 13.9799 16.4406 16.283 14.8113 18.847C13.7963 20.4444 12.7477 21.8156 11.9999 22.6934C11.2521 21.8155 10.2036 20.4443 9.18859 18.847ZM12 14.7608C10.7673 14.7608 9.77138 13.5702 9.77138 12.1142C9.77138 10.6582 10.7673 9.4677 12 9.4677C13.2326 9.4677 14.2285 10.6582 14.2285 12.1142C14.2285 13.5703 13.2326 14.7608 12 14.7608ZM12 13.5663C12.6578 13.5663 13.1999 12.9182 13.1999 12.1142C13.1999 11.3103 12.6578 10.6621 12 10.6621C11.3421 10.6621 10.7999 11.3103 10.7999 12.1142C10.7999 12.9182 11.3421 13.5663 12 13.5663Z" fill="#00000085"></path></svg>
                     Client Location - <span class="text-muted" v-on:click="postDetailsclick(data.jobs_id)">{{data.client_country}}</span></p>
                  <div class="skill-slider-wrapper mt-0">
                    <b-row class="mt-0" v-if="data.skill_name.length > 0">
                      <b-col xl="12" lg="12" md="12" sm="12" class="col-12" :class="'ali-'+data.skill_name.length" v-if="data.skill_name">
                        <div class="skills" :id="'skill-'+index">
                          <!-- {{data.skill_name}} -->
                          <template v-for="(skill,skill_index) in data.skill_name">
                            <!-- {{skill}} -->
                            <span class="skill" :key="skill_index" :class="'skill-'+index" :id="'skill-'+index+'-'+skill_index" >{{(!checkskills('skill',index,skill_index,data.skill_name.length))?'':skill}}</span>
                          </template>
                            <span class="cursor-pointer skill" :id="'skill-append-'+index" :class="'skill-append-'+index" style="display:none;" v-b-toggle.sidebar-right v-on:click="postDetailsclick(data.jobs_id)"></span>
                        </div>
                      </b-col>
                    </b-row>
                  </div>
                </div>
             
                <div class="find-job-pagination-wr">
                  <div class="jobs-per-page-wr">
                    <span>Jobs Per Page:</span>
                    <select v-model="perPage" @change="updatePagination">
                      <option value="10">10</option>
                      <option value="20">20</option>
                      <option value="50">50</option>
                      <option value="100">100</option>
                    </select>
                  </div>
                  <div class="flex">
                    <button class="pagination-prev" @click="prevPage" :disabled="currentPage === 1"><svg xmlns="http://www.w3.org/2000/svg" width="25px" height="25px" viewBox="0 0 24 24" fill="none"><path d="M15 7L10 12L15 17" stroke="#00000075" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></svg></button>
                    <ul>
                        <li 
                          v-for="page in totalPages" 
                          :key="page" 
                          @click="setPage(page)" 
                          :class="{ active: currentPage === page }"
                        >
                          {{ page }}
                        </li>
                        <li v-if="totalPages > 5">...</li>
                      </ul>

                    <button class="pagination-next" @click="nextPage" :disabled="currentPage === totalPages"><svg xmlns="http://www.w3.org/2000/svg" width="25px" height="25px" viewBox="0 0 24 24" fill="none"><path d="M10 7L15 12L10 17" stroke="#000000" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></svg></button>
                  </div>
              </div>
                
              </div>

      

            <!-- Hrashikesh Pandey 12/03/2025 changes end -->
              <template v-else-if="dataStatus && postData.length == 0">
                <div class="p-3">
                  <div class="freelancer-search-loader-box  d-flex align-items-start p-2 rounded mb-3" >
                      <!-- Text Placeholders -->
                      <div class="flex-grow-1">
                        <div class="title-placeholder shimmer mb-2"></div>
                        <div class="subtitle-placeholder shimmer mb-2"></div>
                        <div class="description-placeholder shimmer mb-2"></div>
                        <div class="location-placeholder shimmer mb-2"></div>

                        <!-- Inline Tags -->
                        <div class="d-flex flex-wrap gap-2">
                          <div class="tag-placeholder shimmer"></div>
                          <div class="tag-placeholder shimmer"></div>
                          <div class="tag-placeholder shimmer"></div>
                          <div class="tag-placeholder shimmer"></div>
                          <div class="tag-placeholder shimmer"></div>
                        </div>
                      </div>

                      <!-- Round Shape Placeholder -->
                      <div class="d-flex flex-wrap gap-2">
                        <!-- <div class="round-placeholder shimmer ms-auto"></div> -->
                        <div class="round-placeholder shimmer ms-auto"></div>
                      </div>
                  </div>
                  <div class="freelancer-search-loader-box  d-flex align-items-start p-2 rounded mb-3" >
                      <!-- Text Placeholders -->
                      <div class="flex-grow-1">
                        <div class="title-placeholder shimmer mb-2"></div>
                        <div class="subtitle-placeholder shimmer mb-2"></div>
                        <div class="description-placeholder shimmer mb-2"></div>
                        <div class="location-placeholder shimmer mb-2"></div>

                        <!-- Inline Tags -->
                        <div class="d-flex flex-wrap gap-2">
                          <div class="tag-placeholder shimmer"></div>
                          <div class="tag-placeholder shimmer"></div>
                          <div class="tag-placeholder shimmer"></div>
                          <div class="tag-placeholder shimmer"></div>
                          <div class="tag-placeholder shimmer"></div>
                        </div>
                      </div>

                      <!-- Round Shape Placeholder -->
                      <div class="d-flex flex-wrap gap-2">
                        <div class="round-placeholder shimmer ms-auto"></div>
                        <div class="round-placeholder shimmer ms-auto"></div>
                      </div>
                  </div>
                  <div class="freelancer-search-loader-box  d-flex align-items-start p-2 rounded mb-3" >
                      <!-- Text Placeholders -->
                      <div class="flex-grow-1">
                        <div class="title-placeholder shimmer mb-2"></div>
                        <div class="subtitle-placeholder shimmer mb-2"></div>
                        <div class="description-placeholder shimmer mb-2"></div>
                        <div class="location-placeholder shimmer mb-2"></div>

                        <!-- Inline Tags -->
                        <div class="d-flex flex-wrap gap-2">
                          <div class="tag-placeholder shimmer"></div>
                          <div class="tag-placeholder shimmer"></div>
                          <div class="tag-placeholder shimmer"></div>
                          <div class="tag-placeholder shimmer"></div>
                          <div class="tag-placeholder shimmer"></div>
                        </div>
                      </div>

                      <!-- Round Shape Placeholder -->
                      <div class="d-flex flex-wrap gap-2">
                        <div class="round-placeholder shimmer ms-auto"></div>
                        <div class="round-placeholder shimmer ms-auto"></div>
                      </div>
                  </div>
                </div>
              </template>
              <div v-else>
                <div class="job-card py-8 px-4 pb-4 mb-2 text-center dashboard-empty">
                  <svg width="149" height="149" viewBox="0 0 149 149" fill="none" xmlns="http://www.w3.org/2000/svg" class="mb-2 m-auto">
                    <path d="M66.1246 6.34896C71.2699 2.78071 78.0895 2.78071 83.2348 6.34896C86.5425 8.64289 90.6329 9.51233 94.5877 8.76211C100.74 7.59512 106.97 10.3689 110.219 15.7214C112.307 19.1624 115.691 21.6204 119.609 22.5436C125.703 23.9797 130.266 29.0476 131.057 35.2589C131.566 39.252 133.657 42.8736 136.861 45.3106C141.844 49.1014 143.952 55.5872 142.148 61.5833C140.989 65.438 141.426 69.5969 143.361 73.1263C146.372 78.6164 145.659 85.3986 141.573 90.1427C138.946 93.1926 137.653 97.1697 137.986 101.181C138.504 107.421 135.094 113.327 129.431 115.999C125.791 117.717 122.992 120.824 121.665 124.624C119.6 130.536 114.082 134.544 107.822 134.682C103.798 134.77 99.9778 136.471 97.2192 139.402C92.9283 143.962 86.2577 145.38 80.483 142.96C76.7706 141.404 72.5888 141.404 68.8764 142.96C63.1017 145.38 56.4311 143.962 52.1401 139.402C49.3816 136.471 45.5613 134.77 41.537 134.682C35.277 134.544 29.7598 130.536 27.6946 124.624C26.3669 120.824 23.5687 117.717 19.9282 115.999C14.2654 113.327 10.8556 107.421 11.3732 101.181C11.7059 97.1697 10.4136 93.1926 7.78652 90.1427C3.7 85.3986 2.98715 78.6164 5.99803 73.1263C7.93364 69.5969 8.37075 65.438 7.21125 61.5833C5.40762 55.5872 7.51499 49.1014 12.4986 45.3106C15.7024 42.8736 17.7933 39.252 18.3019 35.2589C19.093 29.0476 23.6562 23.9797 29.7508 22.5436C33.6688 21.6204 37.052 19.1624 39.1407 15.7214C42.3898 10.3689 48.6199 7.59512 54.7716 8.76211C58.7264 9.51233 62.8169 8.64289 66.1246 6.34896Z" fill="#F2613C"/>
                    <path d="M68.7901 83.7077H76.827L84.2389 55.3104L86.8286 44.0586H74.5945L72.8978 55.3104L68.7901 83.7077ZM68.8794 104.961C74.0587 104.961 77.6307 100.496 77.6307 96.0311C77.6307 92.1912 75.1303 89.3336 71.2904 89.3336C66.1111 89.3336 62.5391 93.9772 62.5391 98.3529C62.5391 102.282 65.0395 104.961 68.8794 104.961Z" fill="white"/>
                  </svg>
                  <p class="fz-20 fw-600 text-black mb-0">There are no results that match your search.
                  </p>
                  <p class="fz-20 fw-800 text-black mb-0">Please try adjusting your search keywords or filters.
                  </p>
                </div>
              </div>
              <!-- right side bar  -->
              <sidebar ref="postDetailsc"></sidebar>
            </div>
          </div>
        </b-card>
      </b-col>
    </b-row>
    </div>
  </b-container>
</template>
<script>
  import axios from 'axios'
  import { SearchIcon } from "@vue-hero-icons/solid";
  import { validationMixin } from 'vuelidate'
  // import VueReadMoreSmooth from "vue-read-more-smooth"
  import { mapActions,mapState } from "vuex";
  import sidebar from  "@/components/freelancer/jobDetail-sidebar";

  export default {

    mixins: [validationMixin],

    validations: {
    },
    components : {
      // VueReadMoreSmooth, 
      SearchIcon,
      sidebar
    },
    props:{
    },
    data() {
      return {
        busy:false,
        isHidden: true,
        headToken:'',
        allData: [], 
        postData: [], 
        currentPage: 1,
        perPage: 10, 
        // totalPages: 0,
        dataStatus: true,
        loaderStatus: true,
        filterValue:'',
        categoryData:[],
        search:'',
        proposalDetails:{
          recent_job:0,
        },
        category_data:[],
        category_ids:[],
        categoryModelshow:false,
        clientFullDetails:'',
        
        sortoptions: [
          { value: 'ASC', text: 'Oldest' },
          { value: 'DESC', text: 'Newest'},
          { value: '', text: 'Relevance'},
        ],
        sort:'',
        filtersValue: {
          selectedCategoryData:[],
          experienceLevel:[],
          numberOfProposal:[],
          projectLength:[],
          locationData:[],
          hoursperweek:[],
          searchData:[],
          title:'',
          start_limit:0,
          end_limit:'',
          sort:'DESC',
        },
        location:'',
        locationData:'',
        hideClearBtn:false,
        proposalbtn_text:'Submit a Proposal',
        clientrating:false,
        proposal_url:0,
        projectLengthData:[],
        ExperienceLevelData:[],
        jobLink:'',
        // start_limit:0,
        // end_limit:5,
        titleSearch:'',
        employmentTypeData:'',
        login_user_id:'',
        currentLoginUserData:'',
        sliderScrollData:[],
        searchData:[],
        isAccordion3Visible:false,
        isAccordion5Visible:false,
        isLocationFocused:true,
        isLocationFocusedDesktop:true,
        lcoation:'',
        isFocused:'',
      }
    },
    methods: {
      updatePagination() {
        this.currentPage = 1; // Reset to first page
        // this.totalPages = Math.ceil(this.allData.length / this.perPage);
        this.setPageData();
        this.scrollToTop();
      },
      setPageData() {
        let start = (this.currentPage - 1) * this.perPage;
        let end = start + this.perPage;
        this.postData = this.allData.slice(start, end); 
      },
      nextPage() {
        if (this.currentPage < this.totalPages) {
          this.currentPage++;
          this.setPageData();
          this.scrollToTop();
        }
      },
      prevPage() {
        if (this.currentPage > 1) {
          this.currentPage--;
          this.setPageData();
          this.scrollToTop();
        }
      },
      setPage(page) {
        if (page >= 1 && page <= this.totalPages) {
          this.currentPage = page;
          this.setPageData();
          this.scrollToTop();
        }
      },
      scrollToTop() {
          window.scrollTo({
          top: 0,
          behavior: "smooth"
        })
      },
      async clearSearch() {
        this.titleSearch = ''; // Clear local input
        this.filterByData();
        this.$store.dispatch("searchKey", '');
      } ,
    async gotoSearchPage(search,device){ 
      this.$store.dispatch("searchData", []);
      this.titleSearch = search.search_word;
      this.openSearch(device,search);
    },

    async  getSearchData(){
      this.enterKeyPressCount = 0;
      var res = await this.genericAPIPOSTForNodeRequest({
        requestUrl: "user/getSaveSearch",
        params: { search:this.titleSearch },
      });
      this.searchData = res;
    },

      handleBlur(){
        setTimeout(() => {
          this.searchData = [];
        }, 500);
      },
      // this fun is for to open search page
      openSearch(_v,search) {
        if(!search){
          search = {
            "search_word": this.titleSearch,
            "search_type": 1,
            "search_table": '',
            "search_id": ''
          }
        }
        this.filterByData();
        this.searchData = [];
        this.$store.dispatch("searchKey", search);
        this.saveSearch(search);
      },
      async saveSearch(search){
        var res = await this.genericAPIPOSTForNodeRequest({
          requestUrl: "user/saveSearch",
          params: { search:search },
        });
       console.log(res);
      },  
      handleEnterKey(type) {
        // Increment the counter each time the Enter key is pressed
        //this.enterKeyPressCount++;
         // If Enter has been pressed twice, perform the search and reset the counter
        //if (this.enterKeyPressCount === 2) {
          this.openSearch(type, '');  // Trigger search
         // this.enterKeyPressCount = 0;  // Reset the counter
        //}
      },
      // this fun is for to check skills
      checkskills(classId,pid,cid,_t){
        return setTimeout(() => {
          var maxWidth = document.getElementById(classId+'-'+pid).offsetWidth;
          var certificateListWidth = 40;
          document.querySelectorAll('.'+classId+'-'+pid).forEach(element => {
            certificateListWidth += parseInt(element.offsetWidth)+parseInt(10);
            if(parseInt(maxWidth) < parseInt(certificateListWidth)){
              element.remove();
            }
          });
          if(_t == cid+1){
            var renderCount = document.querySelectorAll('.'+classId+'-'+pid).length;
            // console.log('renderCount',_t,renderCount)
            if(_t > renderCount){
              document.getElementById(classId+'-append-'+pid).textContent = '+'+(_t-renderCount);
              document.getElementById(classId+'-append-'+pid).style.display = 'inline-block';
              // document.getElementById(classId+'-append-'+pid).insertAdjacentHTML('beforeend', '<span id="'+classId+'-'+pid+'-'+(renderCount+1)+'" class="skill">+'+(_t-renderCount)+'</span>');
            }else{
              document.getElementById(classId+'-append-'+pid).style.display = 'none';
            }
          }
          return true;
        }, 100);
      },
      SlideSkill(id,direction,_i){
        var slider_width = document.querySelector('#'+id).parentElement.scrollWidth;
        var main_width = document.querySelector('#'+id).scrollWidth;
        if(direction =='right'){
          if(this.sliderScrollData[_i] > 0){
            this.sliderScrollData[_i] = this.sliderScrollData[_i]+parseInt(slider_width);
          }else{
            this.sliderScrollData[_i] = parseInt(slider_width);
          }
          if(main_width > this.sliderScrollData[_i]){
            const conent = document.querySelector('#'+id);
            conent.scrollLeft += slider_width;
            if(this.sliderScrollData[_i] == main_width){
              document.getElementById('next_'+_i).style.display = 'none';
            }
            document.getElementById('prev_'+_i).style.display = 'block';
          }else if(this.sliderScrollData[_i] >= main_width){
            this.sliderScrollData[_i] = this.sliderScrollData[_i]-parseInt(slider_width);
            document.getElementById('next_'+_i).style.display = 'none';
          }
        }else{
          // currentSlide_position-=slider_width
          this.sliderScrollData[_i] = this.sliderScrollData[_i]-parseInt(slider_width);
          if(this.sliderScrollData[_i] >= 0){
            const conent = document.querySelector('#'+id);
            conent.scrollLeft -= slider_width;
            if(conent.scrollLeft==0){
              document.getElementById('prev_'+_i).style.display = 'none';
            }
            document.getElementById('next_'+_i).style.display = 'block';
          }else if(this.sliderScrollData[_i] < 0){
            document.getElementById('prev_'+_i).style.display = 'none';
            this.sliderScrollData[_i] = this.sliderScrollData[_i]+parseInt(slider_width);
          }
          
        }
        
      },
      // this fun is for to clear all filter value
      clearFilter(){
        this.hideClearBtn=false;
        this.filtersValue = {
          selectedCategoryData:[],
          experienceLevel:[],
          numberOfProposal:[],
          projectLength:[],
          locationData:[],
          hoursperweek:[],
          title:'',
          start_limit:0,
          end_limit:''
        };
        this.postData = [];
        this.getData();
      },
      ...mapActions(["genericAPIPOSTRequest"]),
      // this fun is for to search location for filter
      async searchLocation(){
        const formData = new FormData()
        formData.append('input', this.location);
        var res = await this.genericAPIPOSTRequest({
            requestUrl: "common/getLocationAll",
            params: formData,
        }); 
        if(res.length > 0 ){
          this.locationData = res;
        }
      },
      // THIS FUN IS FOR TO GET CATEGORY
      async getCategory(){ 
        var res = await this.genericAPIPOSTRequest({
            requestUrl: "common/getQpRoleMasterList",
            params: {},
        });  
        if(res.length > 0){
          this.categoryData = res;
        }else{
          this.categoryData='';
        }
      },
      // this function is for to get filter data
      async filterByData() {
        this.allData = [];
        this.postData = [];
        console.log("post data.lengtj", this.postData?.length)
        this.dataStatus = true;
        this.filtersValue.start_limit = 0;
        this.hideClearBtn = this.checkFilterdata();
        this.filtersValue.title = this.titleSearch;
        this.loaderStatus = true;

        try {
          var res = await this.genericAPIPOSTRequest({
            requestUrl: "searchJob",
            params: {
              search: this.filtersValue,
              user_id: this.login_user_id,
            },
          });

          console.log("Filtered data:", res);
          if (res.length === 0) {
            this.proposalDetails = { 
              filterJobcount: 0,
              saved_job: 0,
              recent_job: 0,
            };
            // this.totalPages = 1;
            this.currentPage = 1;
            this.setPageData();
            this.dataStatus = false;
            return;
          } 
          this.allData = res.data; // Store full dataset
          this.proposalDetails = res.dashboard;
          // this.totalPages = Math.ceil(this.allData.length / this.perPage);
          this.currentPage = 1; // Reset to first page on filter change

          this.setPageData(); // Update visible data
          this.dataStatus = false;
        } catch (error) {
          console.error("Error filtering data:", error);
          this.allData = [];
          // this.totalPages = 1;
          this.dataStatus = true;
        }
      },
      //  this fun for to get post data 
      async getData() {
          if (this.busy) return;


          var passApidata = {
            "user_id": this.login_user_id,
            "search": this.filtersValue
          };
        
          try {
            const response = await axios.post(this.$store.state.baseUrl + '/searchJob', passApidata, {
              headers: this.headToken
            });
            console.log(">>>response pavan ",response.data);
            if (response.data.result.length === 0) {
                this.allData = [];
                this.proposalDetails = { 
                  filterJobcount: 0,
                  saved_job: 0,
                  recent_job: 0,
                };
                // this.totalPages = 1;
                this.currentPage = 1;
                this.setPageData();
                this.dataStatus = false;
                return;
            } 

            if (response.data.status) {
              this.allData = response.data.result.data; 
              console.log(">>>response.data.result.data",response.data.result.data);
              console.log("length hai:>>>",response.data.result.data.length)
              this.proposalDetails = response.data.result.dashboard;

              // this.totalPages = Math.ceil(this.allData.length / this.perPage);
              this.$nextTick(() => {
                // console.log("Total Pages Updated:", this.totalPages); // ✅ Debugging
              });
            
              this.setPageData();

              this.dataStatus = this.allData.length === 0;
              
            } else {
              this.allData = [];
              this.dataStatus = true;
            }
          } catch (error) {
            console.error("Error fetching data:", error);
            this.dataStatus = true;
          }
        
        },
      
      // this fun for to check filter array have value
      checkFilterdata(){
        if(this.filtersValue.experienceLevel.length > 0){
          return true; 
        }else if(this.filtersValue.numberOfProposal.length > 0){
          return true; 
        }else if(this.filtersValue.selectedCategoryData.length > 0){
          return true; 
        }else if(this.filtersValue.projectLength.length > 0){
          return true; 
        }else if(this.filtersValue.locationData.length > 0){
          return true; 
        }else if(this.filtersValue.hoursperweek.length > 0){
          return true; 
        }else{
          return false;
        }
      },
  
      
      // this fun is for to Remove select category
      removeFilterValue(key,index){
        if(key=='hoursperweek'){
          this.filtersValue.hoursperweek.splice(index, 1); 
        }
        if(key=='experienceLevel'){
          this.filtersValue.experienceLevel.splice(index, 1); 
        }
        if(key=='numberOfProposal'){
          this.filtersValue.numberOfProposal.splice(index, 1); 
        }
        if(key=='selectedCategoryData'){
          this.filtersValue.selectedCategoryData.splice(index, 1); 
        }
        if(key=='projectLength'){
          this.filtersValue.projectLength.splice(index, 1); 
        }
        if(key=='locationData'){
          this.filtersValue.locationData.splice(index, 1); 
        }
        this.hideClearBtn= this.checkFilterdata();
        this.filterByData();
          // \\OR   
          // this.$delete(this.category_data,index);
        // \\both will do the same
      },
      // this function is for dislike the post
      async dislikePost(post){
        var  passApidata= { "post_id": post, "dislike_reason": "Not Interested"};
        await axios.post(this.$store.state.baseUrl+'/postDislike',passApidata,{headers: this.headToken}).then((response)=>{
          if(response.data.status ==  true){
            // var  passApidata= {
            //     "filter": this.filterValue,
            //     "from": "search",
            //     "search":{"location": [], "locationDis": [], "cid": []}
            // };
            // axios.post(this.$store.state.baseUrl+'/getJobsList',passApidata,{headers: this.headToken}).then((response)=>{
            //   if(response.data.status ==  true){
            //     this.postData = response.data.result;
            //     this.proposalDetails=response.data.dashboard;
            //     this.loaderStatus= false;
            //     if (this.filterValue == '') {
            //       if (this.proposalDetails.filterJobcount > 0) this.dataStatus = false;
            //       else this.dataStatus = true;
            //     }
            //     else if(this.filterValue == 3){
            //       if (this.proposalDetails.saved_job > 0) this.dataStatus = false;
            //       else this.dataStatus = true;
            //     }else{
            //       if (this.proposalDetails.dislike_job > 0) this.dataStatus = false;
            //       else this.dataStatus = true;
            //     }
            //   }else{
            //     this.loaderStatus = false;
            //     this.dataStatus = true;
            //   }
            // });
            this.$toastr.s('Post Disliked successfull');
          }else{
            this.$toastr.e('Post Not Disliked');
          }
        });
      },
      //this fun is for to read jobpost
      async addJobRead(data){
        await this.genericAPIPOSTRequest({
            requestUrl: "addJobread",
            params: {"user_id":this.login_user_id,'job_id': data},
        });
        return true;
      },
      // this function is for get post details
      async postDetailsclick(data){
        this.loading = true; // Show loader
        try {
          await this.$refs.postDetailsc.postDetails(data);
          await this.addJobRead(data);

          document.getElementById(data)?.classList.remove("unread-bg");
          document.getElementById(data)?.classList.add("job-viewed");
        } catch (error) {
          console.error("Error loading job details:", error);
        } finally {
          this.loading = false; // Hide loader
        }
      },
      // this fun for to go job post details
      gotojobDetails(datas) {
        this.$router.push({
                      name: 'jobDetails', 
                      path:'/freelancer/job-details',
                      params: { jobDetailsWithClientData: datas }
                  }).catch(()=>{});
        // window.open(route.href);

      },         
      // this fun for to save & unsave post 
      async savePost(jobdata,_i=null){
        var send_jobdata = {
          "action":3,
          "jobData":jobdata
        };
        var res = await this.genericAPIPOSTRequest({
            requestUrl: "job/addBookmark",
            params: send_jobdata,
        });
        if(res){
          if(jobdata.action == 3){
            // if(_i == 'detail') this.jobDetailsWithClientData.jobDetails.action=null;
            //else
             this.postData[_i].action=null;
            document.getElementById('res_'+jobdata.jobs_id).classList.remove("saved-btn");
            this.$toastr.s('Post UnSaved Successfull');
          }else{
            // if(_i == 'detail') this.jobDetailsWithClientData.jobDetails.action = 3;
            // else 
            this.postData[_i].action=3;
            document.getElementById('res_'+jobdata.jobs_id).classList.add("saved-btn");
            this.$toastr.s('Post Saved Successfull');
          }
        }else{
            this.$toastr.e('Post Save Unsuccessfull');
            this.loaderStatus = false;
            this.dataStatus = true;
        }
      },
      // this fun is for to get Project Length 
      async getProjectLength(){
        var projectData = await this.genericAPIPOSTRequest({
            requestUrl: "getProjectLengths",
            params: {},
        }); 
        if(projectData.length > 0 ){
          this.projectLengthData = projectData;
        }
      },
      // this fun is for to get Project Length 
      async getExperienceLevel(){
        var experienceData = await this.genericAPIPOSTRequest({
            requestUrl: "getExperienceLevel",
            params: {},
        }); 
        if(experienceData.length > 0 ){
          this.ExperienceLevelData = experienceData;
        }
      },
      //this fun for get employment types 
      async getemploymentType(){
        var employmentType = await this.genericAPIPOSTRequest({
            requestUrl: "employmentType",
            params: {},
        }); 
        if(employmentType.length > 0 ){
          this.employmentTypeData = employmentType;
        }
      },
      //this fun for get get Current login User 
      async getCurrentloginUser(){
        var employmentType = await this.genericAPIPOSTRequest({
            requestUrl: "user/getUserDetails",
            params: {
              "user_id":'ASS'+this.encodedid(this.login_user_id),
            },
        }); 
        if(employmentType ){
          this.currentLoginUserData = employmentType;
          if (this.sortoptions.length > 3) {
            this.sortoptions[3].value =employmentType?.country_id;
          }
        }
      },
    },
    watch: {
        postData(newVal) {
          console.log("new val",newVal)
          // this.totalPages = Math.ceil(newVal.length / this.perPage);
          this.totalPages;
        },
        searchValue(newValue, oldValue) {
           console.log(`Search value changed from ${oldValue} to ${newValue}`);
          // // Do something when searchValue changes
          if(newValue)
          {
            this.$store.dispatch("searchKey", newValue);
            this.titleSearch  = newValue.search_word;
            if(newValue?.search_table==='qp_role_master'){
              //this.titleSearch  = "";
              //this.filtersValue.selectedCategoryData.push({"qp_role_master_id":newValue.search_id,"role_name":newValue.search_word,"is_active":1,"is_deleted":0})
            }
            if(newValue.search_table==='qp_role_skill_master'){
              //this.filtersValue.skills.push({"qp_role_skill_master_id":newValue.search_id,"skill_name":newValue.search_word,"is_active":1,"is_deleted":0})
            }
          }else{
            this.titleSearch  =  '';
          }  
          this.filterByData()
        },
    },
    computed:{
      totalPages() {
        return Math.ceil(this.allData.length / this.perPage);
      },
      paginatedData() {
        let start = (this.currentPage - 1) * this.perPage;
        let end = start + this.perPage;
        return this.postData.slice(start, end);
      },
      filteredSearchData() {
        return this.searchData.filter(
          (serach) => serach.search_word && serach.search_word.trim()
        );
      },
      ...mapState(['searchValue']),  
      filteredAndSorted(){
      // function to compare names
        function compare(a, b) {
          if (a.job_title < b.job_title) return -1;
          if (a.job_title > b.job_title) return 1;
          return 0;
        }
        return this.postData.filter(user => {
            return user.job_title.toLowerCase().includes(this.search.toLowerCase());
        }).sort(compare);
      },
      filterCategory(){
      // function to compare names
        function compare(a, b) {
          if (a.job_title < b.job_title) return -1;
          if (a.job_title > b.job_title) return 1;
          return 0;
        }
        return this.categoryData.filter(user => {
            return user.role_name.toLowerCase().includes(this.search.toLowerCase());
        }).sort(compare);
      }
    },
    mounted() {
      var userdata = JSON.parse(localStorage.getItem('loginUserData'));
      this.login_user_id = userdata.login_master_id;
      if(this.$route.params.input != undefined){
        this.titleSearch = this.$route.params.input;
        this.filtersValue.title = this.titleSearch;
      }
      // var userdata = JSON.parse(localStorage.getItem('loginUserData'));
      // -------------------------------this is header for api------------------------------
      this.headToken= {Authorization : 'Bearer '+this.$store.state.currentUserData.token, TimeZone : this.$store.state.userTimeZone};
      //this fun for get employment types
      this.getemploymentType();
      // this function is for to get all categorys 
      this.getCategory();
      // this function is for to get all active jobs
      this.getData();
      // this.filterByData();
      // this fun is for to get Project Length 
      this.getProjectLength();
      // this fun is for to get Project Length 
      this.getExperienceLevel();
      // this fun is for to get Curren tlogin User 
      this.getCurrentloginUser();
      this.searchLocation();
    },  
  }
</script>
<style>
  @import url('https://fonts.googleapis.com/css2?family=Source+Sans+Pro:wght@200;300;400;600;700;900&display=swap');
  body{font-family: 'Source Sans Pro', sans-serif!important;}
  .text-muted{color:#000!important;}
  .ralative {padding-bottom:0px;}
  .theme-bg{background-color: #FFF6F4!important;}
  .bg-none{background-color:transparent;}
   
  .br-20{border-radius: 20px;}
  .border-none{border:0px!important;}
  .search-wrap .br-50{border-radius:50%!important;}
  .search-wrap .fz-14{font-size:14px;}
  .search-wrap .card{border-radius: 20px!important;border: 0px;background-color: transparent;}
  .search-wrap .card-body{border-radius: 20px;}
  .search-wrap .card-body{border-radius:0 0 20px 20px;padding:0px;}
  .search-wrap .card-header{border-radius:0!important;background-color: transparent;text-align: left;border-radius:20px 20px 0 0!important;}
  .search-wrap .my-proposal ul{margin-left:-32px;}
  .search-wrap .tabs .card{border-radius: 20px!important;border: 0px;background-color: #fff;}
  .search-wrap .card-section select{-webkit-appearance: menulist !important; /* override vuetify style */-moze-appearance: menulist !important; /* override vuetify style */appearance: menulist !important; /* override vuetify style */
  }
  .fz-16{font-size:16px;}
  .fz-18{font-size:18px;}
  .fz-24{font-size:24px;}
  .fw-600{font-weight:600;}
  .mb-23{margin-bottom:23px;}
  .no-bottom-border{border-bottom:0px!important;}
  .border-top-0{border-top:0px!important;}
  .fz-34{font-size:34px;}
  .offer-wrap .card-body{padding:0px;}
  .mb-50{margin-bottom:50px!important;}
  p {margin-top: 0!important;margin-bottom: 1rem!important;}
  h6, .h6, h5, .h5, h4, .h4, h3, .h3, h2, .h2, h1, .h1 {margin-top: 0!important;margin-bottom: 0.5rem!important;font-weight: 500!important;line-height: 1.2!important;}
  dl, ol, ul {margin-top: 0!important;margin-bottom: 1rem!important;}
  ol, ul {padding-left: 2rem!important;}
  hr {margin: 1rem 0!important;}  
  .fz-30{font-size:26px!important;}
  .card-section .post {margin-left: -32px;}
  .card-section .tags span {background: #FCFCFC;border: 1px solid #d8d8d8;border-radius: 100px;padding: 1px 15px!important;font-size: 14px;--skill-height: 30px;margin: 0 5px 10px 0;padding: 0 10px;background-color: var(--skill-bg);border-radius: 12px;font-size: 12px;line-height: 2;cursor: default;}
  .btn-edit:hover{padding:8px 16px!important;background-color: #f2613da6!important;}
  .card-section .btn-social{font-family: 'Source Sans Pro';font-style: normal;font-weight: 400;font-size: 14px;line-height: 18px;text-align: center;color: #000000;background: #FFFFFF;border: 1px solid #000000;border-radius: 100px;text-align:center;width:100%;}
  .search-wrap .custom-control-label{background-color:transparent;}
  .border-none{border:0px;}
  .bg-theme{background-color:#F2613C!important;}
  .search-bar .bordered{border:1px solid #D3D3D3!important;border-radius:4px!important;}
  .unread-bg{background-color: #eeeeee66!important;}
  /*.freelancer-wrap .job-card:hover h5{color:#F2613C!important;}*/
  .freelancer-wrap .job-card:hover {background-color: #eeeeee66!important;}
  .up-skill-container {
  --token-btn-gradient: transparent,var(--scroll-gradient-base,var(--semi-transparent-inverse));
  display: grid;
  align-items: center;
}
.bg-hover-theme:hover{background-color:#FFF6F4!important;}
.up-skill-container {
  --token-btn-gradient: transparent,var(--scroll-gradient-base,var(--semi-transparent-inverse));
  display: grid;
  align-items: center;
}
.up-skill-wrapper {
  display: flex;
  overflow-x: auto;
  scroll-behavior: smooth;
  padding: 5px 0 15px;
  scrollbar-width: none;
}
.up-skill-container .up-btn, .up-skill-container .up-skill-wrapper {
  grid-row: 1/-1;
}
.up-skill-badge {
  margin-bottom: 0;
  flex: none;
  cursor: pointer;
}
.up-skill-badge {
  --skill-height: 30px;
  --skill-color:#000;
  --skill-bg: #fff;
  display: inline-flex;
  align-items: center;
  height: var(--skill-height);
  margin: 0 5px 10px 0;
  padding: 0 10px;
  color: #000;
  background-color: #fff;
  border-radius: 15px;
  font-size: 13px;
  line-height: 1;
  cursor: default;
  border:1px solid #F2613C;
  cursor:pointer;
}
.up-skill-container .up-btn:before {
  content: "";
  position: absolute;
  bottom: 0;
  height: 100%;
  width: var(--ws-lg);
}
.up-skill-container .up-btn.up-btn-next {
  padding-left: 10px;
}
.up-skill-container .up-btn {
  position: relative;
  margin: 4px 0 15px;
  height: 100%;
  padding: 0;
}
.up-btn-link {
  padding: var(--btn-link-padding);
  background-color: transparent;
  color: var(--link-color);
  text-transform: none;
  font-weight: var(--btn-weight);
  line-height: var(--font-size-base);
  box-shadow: none!important;
  border-color: transparent;
  border-radius: 0;
  max-height: unset;
}
.up-card-section {
  --card-padding-y: 20px;
}
.skill-slider-wrapper{
  position: relative;
}
.skill-slider-wrapper .prev-btn{
  position: absolute;
  top: -6px;
  z-index: 1;
  background-color: #fff;
  padding: 8px;
  left: 0px;
}
.skill-slider-wrapper .next-btn{
  position: absolute;
  top: -6px;
  z-index: 1;
  background-color: #fff;
  padding: 8px;
  right: 0px;
}
.skill-slider-wrapper .dynamic-slider-slide{
  margin:0 5px;text-align:center;
}
.skill-slider-wrapper .dynamic-slider-slide li{width: 100%;max-width: 100%;overflow: hidden;text-overflow: ellipsis;white-space: nowrap;}


.header-search-wr{
  border: 1px solid #00000025;
  font-size: 15px;
  display: flex;
  padding: 12px 20px 12px 40px;
  width: 100%;
  justify-content: space-between;
  border-radius: 40px;
  transition: 0.2s all ease;
  background-color: #fff;
}
.header-search-wr.mobile{
  width: 100%;
}
.header-search-wr .profile-type-for-search{
  font-weight: 600;

  border-left: 1px solid #00000025;
  padding-left: 10px;
  margin-left: 10px;
}

.header-search-wr svg{
  width: 25px;
  fill: #00000075;
  left: 12px;
  top: 16px;
}


.category-accordion-visible-wr{
  border: 1px solid #00000025;
  margin-top: 5px;
  border-radius: 8px;
}
.category-accordion-visible-wr.inner{
  position: absolute;
  padding: 9px;
  background: #fff;
  z-index: 100;
}

header.card-header.py-3.px-1.category-accordion{
  border: 1px solid #00000035;
  border-radius: 9px !important;
  color: #00000075 !important;
  padding: 9px 10px !important;
}

.category-accordion-visible-wr
input.form-control.bordered,
.category-accordion-visible-wr
input.form-control.border-none {
    border-radius: 11px !important;
}
/* .header-search-wr select:focus{
  outline: 0 !important;
  border: 0 !important;
} */
.header-search-wr input{
  width: 100%;
}
.header-search-wr input,
.header-search-wr input:active,
.header-search-wr input:focus{
  border: 2px solid transparent !important;
  outline: 0 !important;
}


.category-accordion{
  border: 1px solid #00000035;
  border-radius: 9px !important;
  color: #00000075 !important;
  padding: 9px 10px !important;
}
.category-accordion a{
  color: #00000075 !important;
}

.reset-header-search{
  height: 10px;
  width: 10px;
  display: flex;
  justify-content: center;
  border-radius: 50%;
  align-items: center;
  cursor: pointer;
  padding: 9px 9px;
  border: 2px solid #00000055;
  font-size: 12px;
  color: #00000055 !important;
  text-align: center;
  transition: 0.2s all ease;
  right: 4%; 
    top: 15px;
    z-index: 10;
    cursor: pointer;
    background: #fff;
    position: absolute;
}

.header-search-wr.typing,
.header-search-wr.focused{
  padding: 0;
  background: #E9E9E9;
  border: 0;
  padding-right: 10px;
  transition: 0.2s all ease;
}
.header-search-wr.find-job,
.header-search-wr.typing.find-job,
.header-search-wr.focused.find-job{
  padding: 0;
  background: transparent;
  border: 0;
  padding-right: 10px;
  transition: 0.2s all ease;
}
.header-search-wr.typing span,
.header-search-wr.typing svg,
.header-search-wr.focused span,
.header-search-wr.focused svg{
  position: absolute;
}

.header-search-wr.typing.find-job span{
  right: 4%;
}
.header-search-wr.find-job svg
.header-search-wr.typing svg,
.header-search-wr.focused svg
{
  top: 15px;
}

.header-search-wr.typing input,
.header-search-wr.typing input:active,
.header-search-wr.typing input:focus{
  border: 2px solid #00000025 !important;
}
.header-search-wr.typing input:focus,
.header-search-wr.focused input:focus{
  transition: 0.2s all ease;
}
.header-search-wr.typing input,
.header-search-wr.focused input{
  background: #fff;
  width: 100%;
  border-radius: 30px;
  padding:14px 20px 14px 40px;
  transition: 0.2s all ease;
}
.header-search-wr.find-job input{
  background: #fff;
  width: 100%;
  border-radius: 30px;
  padding:14px 50px 14px 40px;
  transition: 0.2s all ease;
  border: 2px solid #00000025 !important;
}
.header-search-wr.typing .profile-type-for-search,
.header-search-wr.focused .profile-type-for-search{
  padding: 10px;
  border: 0;
  transition: 0.2s all ease;
  display: flex;
  margin: 0px;
  align-items: center;
  justify-content: center;
}
.auto-fill-data-wr{
  background-color: #fff;
  position: absolute;
  width: 100%;
  left: 0;
  border: 1px solid #00000025;
  border-radius: 15px;
  transition: 0.2s all ease;
  opacity: 0;
  pointer-events: none;
  top: 0;
  height: fit-content;
  overflow-y: auto;
}
.header-search-wr.typing .auto-fill-data-wr,
.header-search-wr.focused .auto-fill-data-wr{
  top: 110%;
  z-index: 100;
  opacity: 1;
  pointer-events: all;
}
.auto-fill-data-wr ul{
  margin-bottom: 0 !important;
  padding: 10px;
  padding-left: 10px !important;
}
.auto-fill-data-wr li{
  position: relative;
  padding: 5px 10px 5px 40px;
  overflow-wrap: break-word;
  transition: 0.2s all ease;
  border-radius: 15px;
  
}
.auto-fill-data-wr li:hover{
  cursor: pointer;
  background: #00000015;
}
.header-search-wr.typing
.auto-fill-data-wr li svg,
.header-search-wr.focused
.auto-fill-data-wr li svg{
  left: 10px;
  top: 6px;
}

.header-search-wr.typing.mobile span,
.header-search-wr.focused.mobile span {
    right: 14%;
    top: 19px;
}
.btn-archive.heart{
  padding: 10px !important;
  border: 2px solid #00000025;
}

.saved-job-filter-wr{
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.saved-job-filter-wr > ul{
  margin-bottom: 0 !important;
}

.saved-jobs-text-wr{
  display: flex;
  align-items: center;
  justify-content: center;
}
.saved-jobs-text-wr button,
.number-of-saved-jobs{
  color: #F2613C !important;
}

.number-of-saved-jobs{
  font-weight:600;
}

.sort-jobs-wr{
  border: 2px solid #00000025;
  padding: 10px 10px !important;
  border-radius: 8px;
}
.sort-jobs-wr
.custom-select{
  margin-top:0 !important;
  min-width: 120px;
  font-weight: 600;
  padding: 0 !important;
  border: 0 !important;
}

.job-posted-text{
  color: #00000075 !important;
    font-size: 14px;
    margin-bottom: 4px;
    font-weight: 600;
    display: block;
}

.find-job-flex{
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding-right:10px ;
  gap:6px;
  color: #00000085;
}
.freelancer-search-page-ul{
  gap: 20px ;
}
.client-location{
  font-size: 14px !important;
  font-weight: 600;
  margin-bottom: 10px !important;
  margin-top: 20px !important;
  color: #00000085 !important;
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: fit-content;
  gap: 5px;
}

/* Hide default checkbox */
.custom-checkbox-input {
  display: none;
}

/* Custom checkbox design */
.custom-checkbox-box {
  width: 22px;
  height: 21px;
  border: 1px solid #00000065;
  background-color: white;
  display: inline-block;
  margin-right: 10px;
  border-radius: 4px;
  vertical-align: middle;
  position: relative;
  transition: all 0.3s ease-in-out;
}

/* Add checkmark when checked */
.custom-checkbox-input:checked + .custom-checkbox-box {
  background-color: #00000065;
  border-color: #00000065;
}

label.custom-checkbox-label {
    margin-bottom: 15px;
    display: flex;
    align-items: flex-start;
    justify-content: flex-start;
}

.custom-checkbox-input:checked + .custom-checkbox-box::after {
  content: "✔";
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  color: white;
  font-size: 14px;
  font-weight: bold;
}

@media (max-width: 567px) {
  .input-group.search-bar{
    width: 90% ;
  }
}
@media (max-width: 567px) {
.d-flex.align-items-center.mt-2.save-job-sort-wr{
  flex-direction: column;
  align-items:flex-start !important;
}
.saved-job-filter-wr > ul{
  padding-left: 0 !important;
}

ul.flex.align-items-center.fw-600.fz-14.post.text-muted.mb-2.freelancer-search-page-ul {
    flex-direction: column;
    align-items: flex-start !important;
    gap: 0;
}
}

@media (max-width: 479px) {

ul.flex.align-items-center.fw-600.fz-14.post.text-muted.mb-2.freelancer-search-page-ul {
    flex-direction: column;
    align-items: flex-start !important;
    gap: 0;
}
}

@media (max-width: 414px) {
  .saved-job-filter-wr{
    flex-direction: column;
    align-items: flex-start;
  }
}

</style>